import { sys } from '@/api/defineRouting.ts'
import type { ResponseBody } from '@/types'

export const staffServices = {
  async search(params?: any) {
    const res: ResponseBody = await usePost(`${sys.STAFF_SEARCH}`, params)
    return res
  },
  async searchSystemCrm(params?: any) {
    const res: ResponseBody = await useGet(`${sys.STAFF_SEARCH_SYSTEM_CRM}`, { params })
    return res
  },
  async searchOrgUnitId(params?: any) {
    const res: ResponseBody = await usePost(`${sys.STAFF_SEARCH_ORGUNIT_ID}`, params)
    return res
  },
}

export const staffUnit = {
  async searchStaff(params?: any) {
    const res: ResponseBody = await usePost(`${sys.GET_ORG_UNIT}`, params)
    return res
  },
}
